'use client';
import Image from "next/image";

export default function ItemCard({ isProduct, skipCategories, item, lang, view }) {
  const cardItem = item.translations

  return (
    <div className="group relative bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 flex flex-col">
      {/* Image Container - 600x400 aspect ratio (3:2) */}
      <div className="relative w-full aspect-[3/2] overflow-hidden bg-gray-200">
        <Image
          src={process.env.CMS_URL + 'assets/' + item.image.filename_disk}
          alt={item.image.description}
          fill
          className="object-contain object-center group-hover:opacity-75 transition-opacity duration-300"
        />
      </div>

      {/* Content Container - Flexible Height */}
      <div className="flex-1 p-4 flex flex-col">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 line-clamp-1 group-hover:text-chimia-700 transition-colors duration-200">
            {cardItem.title}
          </h3>
          
          <p className="mt-1 text-xs text-gray-500">
            products / {isProduct ? item.category.section.translations.title + ' / ' + item.category.translations.title : item.section.translations.title}
          </p>
          
          <p className="mt-2 text-sm text-gray-600 line-clamp-3">
            {cardItem.shortDescription}
          </p>
        </div>

        {/* Button Container - Fixed at Bottom */}
        <div className="mt-4 text-center">
          <a href={`${isProduct ? '/product/' + item.category.section.translations.slug + '/' + item.category.translations.slug : skipCategories ? '/product/' + item.section.translations.slug + '/' + cardItem.slug : '/products/' + item.section.translations.slug}` + '/' + cardItem.slug}>
            <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-chimia-700 hover:bg-chimia-800 transition-colors duration-200">
              {view}
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}